import jQuery from "jquery";
window.jQuery = jQuery;
$ = jQuery;

import { getUrlParameter, hasUrlParameter, forceInt, forceFloat, getCurrenLocaleObj } from "../functions";

window.globalOrderTotal = 0;

$(function() {
    const $genericPaymentConfirmationPage = $('.GenericPaymentConfirmationPage');
    if (!$genericPaymentConfirmationPage.length) return false;

    const currenLocaleObj = getCurrenLocaleObj();

    const checkoutExtraDataFormsInit = function () {
        const $orderItemCheckoutFormWrappers = $('.order-item-checkout-form');
        if ($orderItemCheckoutFormWrappers.length) {
            $orderItemCheckoutFormWrappers.each(function() {
                const $this = $(this),
                    $form = $this.find('form');

                $form.parsley();

                $form.parsley().on('form:submit', function(formInstance) {
                    formInstance.submitEvent.preventDefault();

                    return false;
                });
            });
        }
    };

    checkoutExtraDataFormsInit();

    // Coupon Functionality
    // $(".form-default").on("touch click", ".js-prompt", function() {
    $genericPaymentConfirmationPage.on("touch click", ".js-prompt", function() {
        $(".js-reveal")
            .stop()
            .show("fast");
        $(".js-prompt").hide();
    });
    // $(".form-default").on("change", "#couponInput", function() {
    $genericPaymentConfirmationPage.on("change", "#couponInput", function() {
        $("#couponInput")
            .parsley()
            .reset();
        $(".parsley-error").removeClass("parsley-error");
    });
    // $(".form-default").on("touch click", ".js-applyCoupon", function(e) {
    $genericPaymentConfirmationPage.on("touch click", ".js-applyCoupon", function(e) {
        e.preventDefault();
        $("#couponInput")
            .parsley()
            .validate();
    });
    $.listen("parsley:field:success", function(parsleyField) {
        if (parsleyField.$element.attr("name") !== "couponInput") {
            return;
        }

        const $hpaCheckoutCouponMessage = $('#hpa-checkout-coupon-message');
        if ($hpaCheckoutCouponMessage.length) $hpaCheckoutCouponMessage.hide();

        const $couponFieldBtn = $('.js-applyCoupon');
        $couponFieldBtn.attr('disabled', true);
        var coupon = {};
        coupon.coupon = $("#couponInput").val();
        coupon.orderId = $orderId.val();
        $.post('/PaymentController/applycoupon?l=' + currenLocaleObj.locale, coupon, function(data) {
            data = JSON.parse(data);
            var field = $("#couponInput").parsley();
            window.ParsleyUI.removeError(field, "ajax");
            if (data.success === "false") {
                window.ParsleyUI.addError(field, "ajax", data.message);
            }

            $couponFieldBtn.removeAttr('disabled');

            if (data.success === "true") {
                // dirty page refresh to load the free payment form
                if (data.newtotal === "$0.00 USD") {
                    // window.location.reload(true);

                    if ($ppSections.length) {
                        $ppSections.remove();
                    }

                    // const $paymentPlanSection = $('.payment-plan-section');
                    // if ($paymentPlanSection.length) {
                    //     $paymentPlanSection.remove();
                    //     // $paymentPlanSection.find('#PaymentPlan0').attr('checked', true);
                    // }

                    const $paymentMethods = $('.payment-methods');
                    if ($paymentMethods.length) {
                        $paymentMethods.remove();

                        const $paymentForm = $('form.js-ga_checkout');
                        if ($paymentForm.length) {
                            $paymentForm.append('<input type="hidden" name="PaymentType" value="Free" />');
                        }
                    }

                    const $formBtn = $('.js-ga_checkoutSubmit');
                    if ($formBtn.length) {
                        $formBtn.text(hpaTranslatedtext.confirmation.redeemButtonText); // Click here to Redeem
                    }

                    $googlepayBtn.hide();
                    $applepayBtn.hide();
                    $wcCreditCardBtn.hide();
                    $payNow.show();
                }

                // Display applied message
                $(".js-applied")
                    .stop()
                    .show("fast");
                $(".js-reveal").hide();

                // add Line Item into Table
                if (data.newcoupon === "true") {
                    const currentTotalsCouponCodeRow = $('.totals-coupon-code');
                    if (currentTotalsCouponCodeRow.length) {
                        currentTotalsCouponCodeRow.remove();
                    }
                    var tableRowHTML =
                        "<tr class=\"totals-coupon-code\">" + "<td>" + data.title + "</td>" + "<td>" + data.discount + "</td>" + "</tr>";
                    $("table tbody tr:last").after(tableRowHTML);
                }

                // newtotalInCents
                let newTotal = forceFloat(data.newtotalInCents / 100);
                newTotal = newTotal.toFixed(2);
                updateTotals(newTotal);

                // var $adjustTotal = $(".js-total");
                // // update all Total Prices on page
                // $adjustTotal.each(function() {
                //     var $el = $(this);
                //     var adjustTotalByWeeks = $el.data("weeks");
                //     if (adjustTotalByWeeks) {
                //         //Adjust Payment pan prices
                //         var total = data.newtotalInCents / adjustTotalByWeeks / 100;
                //         $el.text("$" + total.toFixed(2) + " USD");
                //     } else {
                //         $el.text(data.newtotal);
                //     }
                // });
            }
        });
    });

    // payment Plan reveling
    // $("body").on("touch click", ".js-prompt--paymentPlan a", function(e) {
    //     e.preventDefault();
    //     // $(".js-reveal--paymentPlan")
    //     //     .stop()
    //     //     .show("fast");
    //     // $(".js-prompt--paymentPlan").hide();
    //     paymentPlanShow();
    // });

    var $paymentForm = $("#PaymentConfirmationForm_PaymentConfirmationForm"),
        $membershipPaymentForm = $("#MembershipPaymentsForm_MembershipPaymentsForm"),
        $credit = $("#RadioCreditCard"),
        $paypal = $("#RadioPayPal"),
        $paypalBtn = $("#paypal-button-container"),
        $googlePay = $('#RadioGooglePay'),
        $googlepayBtn = $('#googlepay-btn'),
        $applePay = $('#RadioApplePay'),
        $applepayBtn = $('#applepay-btn'),
        $applepaySections = $('.applepay-section'),
        $wcCreditCard = $('#RadioWcCreditCard'),
        $wcCreditCardBtn = $('#wc-creditcard-btn'),
        $wcCreditCardMethods = $('.wc-credit-card-method-radio'),
        $wcCreditCardMethodToken = $('#wc-credit-card-token'),
        $voucher = $("#RadioVoucher"),
        $payNow = $("#btnPayNow"),
        $subMethods = $("#step2-Credit"),
        $loginRegisterSection = $('.login-register'),
        $notLoggedInError = $('.notification.not-logged-in'),
        $formError = $('.form-error'),
        $orderId = $('#OrderID'),
        $paymentMethodsWrapper = $('.payment-methods'),
        $paymentMethodsOverlay = $paymentMethodsWrapper.find('.payment-methods__not-logged-in-overlay'),
        $ppSectionTop = $('.payment-plan-section-top'),
        $ppSectionStep = $('.payment-plan-section-step'),
        $paymentPlanStepOverlay = $ppSectionStep.find('.payment-plan-section-step__not-logged-in-overlay'),
        $paymentMethodRadios = $('.payment-method-radio'),
        $creditCardSubMethodRadios = $('.payment-sub-method-radio'),
        $paymentPlanOptions = $('.paymentplan-option-master'),
        $paymentPlanLink = $('.js-prompt--paymentPlan a'),
        $couponField = $('#couponInput'),
        $couponFieldBtn = $('.js-applyCoupon'),
        $formPaymentPlanOptions = $('input[name="PaymentPlan"]'), // the payment plan radio fields within the form
        $ppSections = $('.js-pp-section'),
        $ppOptions = $('.js-pp-options'),
        $ppBtns = $('.js-pp-btns'),
        $underBtnText = $('.js-under-btn-selected-option'),
        layoutState = {
            paymentPlanOptionsOpen: false,
            mobile: {
                paymentMethodsDisabled: false,
            },
            desktop: {
                paymentPlansOptionsDisabled: false,
                paymentMethodsDisabled: true,
            }
        };

    // BOF: PaymentPlan Functions
    const updateOverlays = function() {
        if (window.matchMedia('(min-width: 992px)').matches) {
            if (layoutState.desktop.paymentPlanOptionsDisabled) {
                $paymentPlanStepOverlay.show();
            } else {
                $paymentPlanStepOverlay.hide();
            }
            if (layoutState.desktop.paymentMethodsDisabled) {
                $paymentMethodsOverlay.show();
            } else {
                $paymentMethodsOverlay.hide();
            }
        } else {
            if (layoutState.mobile.paymentMethodsDisabled) {
                $paymentMethodsOverlay.show();
            } else {
                $paymentMethodsOverlay.hide();
            }
        }
    };

    // fix for when in mobile view and desktop pp options are hidden. height and width were set to 1px
    const ppOptionsFixHeight = function() {
        return false;

        if (layoutState.paymentPlanOptionsOpen) {
            $ppOptions.css('height', 'auto').css('width', 'auto'); // It will do it for desktop and mobile
        }
    }

    const ppSelectedOption = function() {
        let selectedOption = null;
        if ($formPaymentPlanOptions.length) {
            const $selectedOptionField = $formPaymentPlanOptions.filter(':checked');
            if ($selectedOptionField.length) selectedOption = $selectedOptionField;
        }

        return selectedOption;
    }

    const ppOptionsSelectedValue = function() {
        let value = '';
        if ($formPaymentPlanOptions.length) {
            const $paymentPlanOptionChecked = $formPaymentPlanOptions.filter(':checked');
            if ($paymentPlanOptionChecked.length) {
                value = $paymentPlanOptionChecked.val();
                if (value === '') value = '0';
            }
        }

        return value;
    }

    const ppOptionsShow = function() {
        if ($ppOptions.length) {
            updateUnderBtnText();
            $ppOptions.show();
            $ppBtns.hide();

            layoutState.paymentPlanOptionsOpen = true;

            if (getOrderId()) {
                layoutState.desktop.paymentMethodsDisabled = false;
                updateOverlays();
            }
        }
    }

    const ppOptionsSelectLowest = function() {
        if ($ppOptions.length) {
            const lowestId = $ppOptions.first().data('lowestId');
            if (lowestId) {
                const $options = $('.paymentplan-option-' + lowestId);
                if ($options.length) {
                    $options.prop('checked', true);
                }
            }
        }
    }

    const ppSectionsShow = function() {
        if (window.matchMedia('(min-width: 992px)').matches) {
            $ppSectionTop.hide();
            $ppSectionStep.show();
        } else {
            $ppSectionTop.show();
            $ppSectionStep.hide();
        }
    }

    const ppSectionsHide = function() {
        if ($ppSections.length) {
            $ppSections.hide();
        }
    }
    // EOF: PaymentPlan Functions

    const getOrderId = function() {
        let orderID = 0;
        const $orderId = $('#OrderID');
        if ($orderId.length) orderID = forceInt($orderId.val());

        return orderID;
    }

    let applepayAvailable = false;
    if ((window.location.protocol === 'https:') && (typeof window.ApplePaySession !== 'undefined')) {
        if (window.ApplePaySession.canMakePayments()) {
            applepayAvailable = true;
            $applepaySections.show();
        }
    }

    $(".form-default").on("touch click", ".payment-method-radio", function() {
        var paymentMethodValue = $(this).val();
        const $paymentPlanSections = $('.js-payment-plan-section');
        $(".payment-method-form").hide();

        $("#step2-" + paymentMethodValue)
            .stop()
            .show("fast");

        // $paypalBtn.hide(); // for PayPal2
        $googlepayBtn.hide();
        $applepayBtn.hide();
        $wcCreditCardBtn.hide();
        $payNow.show();
        if (paymentMethodValue === 'WcCreditCard') {
            $wcCreditCardBtn.show();
            $payNow.hide();
        // } else if (paymentMethodValue === 'PayPal') { // for PayPal2
        //     $paypalBtn.show();
        //     $payNow.hide();
        } else if (paymentMethodValue === 'GooglePay') {
            $googlepayBtn.show();
            $payNow.hide();
        } else if (applepayAvailable && paymentMethodValue === 'ApplePay') {
            $applepayBtn.show();
            $payNow.hide();
        }

        $underBtnText.show();
        if (paymentMethodValue === 'Voucher') {
            $underBtnText.hide();
        }

        if (paymentMethodValue === 'WcCreditCard' && $wcCreditCardMethods.length) {
            // At the moment token is always checked
            // const $wcCreditCardMethod = $wcCreditCardMethods.filter(':checked');
            // if ($wcCreditCardMethod.length) {
            //     $wcCreditCardMethod.trigger('click');
            // } else {
            //     $wcCreditCardMethodToken.trigger('click');
            // }
        } else if (paymentMethodValue === "Credit" && $subMethods.length) {
            // $("#RadioToken").click();
            if ($creditCardSubMethodRadios.length) {
                const $creditCardSubMethodChecked = $creditCardSubMethodRadios.filter(':checked');
                if ($creditCardSubMethodChecked.length) {
                    $creditCardSubMethodChecked.trigger('click');
                } else {
                    $("#RadioToken").click();
                }
            }
        } else {
            $(".step2-sub").hide();
            $("#step2-sub-" + paymentMethodValue)
                .stop()
                .show("fast");
            $("#btnPayNow").prop("disabled", false);
        }
    });

    $(".form-default").on("touch click change", ".payment-sub-method-radio", function() {
        var paymentSubMethodValue = $(this).val();
        $(".step2-sub").hide();
        $("#step2-sub-" + paymentSubMethodValue)
            .stop()
            .show("fast");
        $("#btnPayNow").prop("disabled", false);
    });

    $wcCreditCardMethods.on('click', function() {
        const $this = $(this),
            $wcCreditCardForm = $('#step2-WcCreditCard-new');

        if ($this.val() === 'WcCreditCard') {
            $wcCreditCardForm.show();
        } else {
            $wcCreditCardForm.hide();
        }
    });

    // select credit card payment option by default
    // if ($credit.length) {
    //     $credit.trigger('click');
    // }
    if ($paymentMethodRadios.length) {
        const $paymentMethodChecked = $paymentMethodRadios.filter(':checked'),
             paymentMethodCheckedName = $paymentMethodChecked.val();
        if ($paymentMethodChecked.length && (paymentMethodCheckedName !== 'ApplePay' || (paymentMethodCheckedName === 'ApplePay' && applepayAvailable))) {
            $paymentMethodChecked.trigger('click');
        } else {
            if ($credit.length) {
                $credit.trigger('click');
            } else if ($wcCreditCard.length) {
                $wcCreditCard.trigger('click');
            } else if ($paypal.length) {
                $paypal.trigger('click');
            } else if ($googlePay.length) {
                $googlePay.trigger('click');
            } else if (applepayAvailable && $applePay.length) {
                 $applePay.trigger('click');
            }
        }
    }

    if ($couponField.length && $couponFieldBtn.length) {
        const couponCode = $couponField.val();
        if (couponCode !== '') {
            $couponFieldBtn.trigger('click');
        }
    }

    if ($('#MembershipPaymentsForm_MembershipPaymentsForm').length) {
        $('#RadioCreditCard').trigger('click');
    }

    if ($paymentForm.length) {
        const $hpaCheckoutEmailForm = $('#HPACheckoutEmailForm_HPACheckoutEmailForm'),
            $hpaCheckoutEmailFormBtn = $('#HPACheckoutEmailForm_HPACheckoutEmailForm_action_doSubmit'),
            $hpaCheckoutEmailForm_FirstName = $('#HPACheckoutEmailForm_HPACheckoutEmailForm_FirstName'),
            $hpaCheckoutEmailForm_LastName = $('#HPACheckoutEmailForm_HPACheckoutEmailForm_Surname'),
            $hpaCheckoutEmailForm_Email = $('#HPACheckoutEmailForm_HPACheckoutEmailForm_Email');

        if ($hpaCheckoutEmailForm.length && !$hpaCheckoutEmailFormBtn.length) {
            if ($hpaCheckoutEmailForm_FirstName.length) {
                $hpaCheckoutEmailForm_FirstName.on('blur', function() {
                    $hpaCheckoutEmailForm.trigger('submit');
                });
            }
            if ($hpaCheckoutEmailForm_LastName.length) {
                $hpaCheckoutEmailForm_LastName.on('blur', function() {
                    $hpaCheckoutEmailForm.trigger('submit');
                });
            }
            if ($hpaCheckoutEmailForm_Email.length) {
                $hpaCheckoutEmailForm_Email.on('blur', function() {
                    $hpaCheckoutEmailForm.trigger('submit');
                });
            }
        }


        $('#HPALoginRegisterForm_HPALoginRegisterForm, #HPACheckoutEmailForm_HPACheckoutEmailForm').on('submit', function(e) {
            e.preventDefault();

            const $this = $(this),
                formData = $this.serialize(),
                url = $this.attr('action') + '?l=' + currenLocaleObj.locale,
                formName = $this.attr('id'),
                $submitButton = $('#' + formName + '_action_doSubmit'),
                submitButtonOldVal = $submitButton.val(),
                submitButtonProcessingtext = $submitButton.data('processing-text'),
                $fieldFirstName = $('#' + formName + '_FirstName'),
                $fieldLastName = $('#' + formName + '_Surname'),
                $fieldEmail = $('#' + formName + '_Email'),
                $fieldPassword = $('#' + formName + '_Password'),
                $orderItemsWrapper = $('#order-items-table-wrapper'),
                $orderItemsAjaxLoader = $('.order-items-ajax-loader'),
                $loginRegisterSection = $('.login-register-section'),
                $parsleyErrorFields = $this.find('.parsley-errors-list');

            $notLoggedInError.hide();
            if ($fieldFirstName.length) $fieldFirstName.parsley().removeError('Email');
            if ($fieldLastName.length) $fieldEmail.parsley().removeError('Email');
            if ($fieldEmail.length) $fieldEmail.parsley().removeError('Email');
            if ($fieldPassword.length) $fieldPassword.parsley().removeError('Password');

            if (formName === 'HPACheckoutEmailForm_HPACheckoutEmailForm') {
                if ($fieldFirstName.val() === '' || $fieldLastName.val() === '' || $fieldEmail.val() === '') {
                    return;
                }

                $loginRegisterSection.hide();
                $orderItemsAjaxLoader.show();
                if ($parsleyErrorFields.length) {
                    $parsleyErrorFields.html(''); // .remove() wasn't working
                }
            }

            $submitButton.val(submitButtonProcessingtext);
            $submitButton.attr('disabled', true);

            $.ajax({
              type: 'POST',
              url: url,
              data: formData,
              dataType: 'json',
            }).done(function (data) {
                // console.log(data);
                if (data.status === 1) {
                    if (data.orderID > 0) {
                        $submitButton.val(submitButtonOldVal);
                        $submitButton.removeAttr('disabled');
                        $('#OrderID').val(data.orderID);
                        $('#OrderID').trigger('change');

                        // Update the Order Items
                        if ($orderItemsWrapper.length && $orderItemsAjaxLoader.length) {
                            $orderItemsWrapper.hide();
                            $orderItemsAjaxLoader.show();

                            let url = '/payment/orderItemsTable';
                            if (window.location.search != '') url += window.location.search; // add GET params
                            url += (url.includes('?') ? '&' : '?') + 'l=' + currenLocaleObj.locale;

                            $.ajax({
                                type: 'GET',
                                url: url,
                                dataType: 'html',
                            }).done(function (html) {
                                $orderItemsWrapper.html(html);
                                $orderItemsWrapper.show();
                                $orderItemsAjaxLoader.hide();

                                checkoutExtraDataFormsInit();

                                // const $adjustTotals = $('.js-total');
                                // let orderTotal = $('#order-total').data('order-total');
                                // orderTotal = parseFloat(orderTotal);
                                // if (isNaN(orderTotal)) orderTotal = 0;
                                // if (orderTotal > 0) {
                                //     // update all Total Prices on page
                                //     $adjustTotals.each(function() {
                                //         const $this = $(this),
                                //             adjustTotalByWeeks = $this.data('weeks');
                                //         if (adjustTotalByWeeks) {
                                //             // Adjust Payment pan prices
                                //             let total = orderTotal / adjustTotalByWeeks;
                                //             $this.text('$' + total.toFixed(2) + ' USD');
                                //         } else {
                                //             $this.text('$' + orderTotal.toFixed(2) + ' USD');
                                //         }
                                //     });
                                // }

                                let orderTotal = $('#order-total').data('order-total');
                                orderTotal = parseFloat(orderTotal);
                                updateTotals(orderTotal);
                            });
                        }

                        let messagesHTML = '';
                        if (data.messages) {
                            for (let n = 0, m = data.messages.length; n < m; n++) {
                                const message = data.messages[n];
                                messagesHTML += '<div class="notification reminder-note remove ' + message.type + ' open" role="alert">' +
                                    '<div class="container">' +
                                        '<h4>' + message.text + '</h4>' +
                                    '</div>' +
                                '</div>';
                            }
                        }
                        if (messagesHTML.length) {
                            $('.checkout-notifications').append(messagesHTML);
                            $('html, body').animate({
                                scrollTop: $('.checkout-notifications').offset().top
                            });
                        }

                        if (data.hasCoupon) {
                            $('.details-form__coupon__applied').removeClass('js-applied').addClass('js-applied-show');
                        } else {
                            $('.details-form__coupon__applied').removeClass('js-applied-show').addClass('js-applied');
                        }

                    }
                } else if (data.status === 0 && data.errors.length) {
                    if (formName === 'HPACheckoutEmailForm_HPACheckoutEmailForm') {
                        $loginRegisterSection.show();
                        $orderItemsAjaxLoader.hide();
                    }
                    $submitButton.val(submitButtonOldVal);
                    $submitButton.removeAttr('disabled');
                    data.errors.forEach(function (error, i) {
                        const field = $('#' + formName + '_' + error.field);
                        if (field.length) {
                            field.parsley().addError(error.field, { message: error.message });
                        }
                    });
                }

            });
        });

        $orderId.on('change', function() {
            const $this = $(this);
            let orderID = parseInt($this.val());
            if (isNaN(orderID)) orderID = 0;

            if (orderID > 0) {
                $('.login-register-section').hide();
                $('.svg-icon-checkout-login-green-tick-wrapper').removeClass('hidden');

                // $paymentMethodsOverlay.hide();
                layoutState.mobile.paymentMethodsDisabled = false;
                layoutState.desktop.paymentPlanOptionsDisabled = false;
                if (layoutState.paymentPlanOptionsOpen || !$ppOptions.length) {
                    layoutState.desktop.paymentMethodsDisabled = false;
                } else {
                    layoutState.desktop.paymentMethodsDisabled = true;
                }

                updateOverlays();
            }
        });

        $paymentForm.parsley().subscribe("parsley:form:validate", function(formInstance) {
            let paymentType = '',
                paymentPlanPayments = '0',
                submitForm = false;

            // else stop form submission
            formInstance.submitEvent.preventDefault();

            // submit the form if it's in the Free State
            var isFreeForm = $paymentForm.serializeArray().filter(function(item) {
                if (item.name === "PaymentType") {
                    paymentType = item.value;
                } else if (item.name === "PaymentPlan") {
                    paymentPlanPayments = item.value;
                }

                return item.name === "PaymentType" && item.value === "Free";
            }).length;

            $formError.hide();
            $notLoggedInError.hide();

            if (!loggedInCheck()) {
                return false;
            }

            const itemExtraDataForms = [];
            let checkoutFormsValid = true;
            const $orderItemCheckoutFormWrappers = $('.order-item-checkout-form');
            if ($orderItemCheckoutFormWrappers.length) {
                $orderItemCheckoutFormWrappers.each(function() {
                    const $this = $(this),
                        $form = $this.find('form');
                    let formData = [];

                    $form.parsley().validate();
                    if ($form.parsley().isValid()) {
                        formData = $form.serializeArray();
                        formData.push({
                            name: 'OrderId',
                            value: $this.data('order-id')
                        });
                        formData.push({
                            name: 'OrderItemId',
                            value: $this.data('order-item-id')
                        });
                        itemExtraDataForms.push(formData);

                    } else {
                        checkoutFormsValid = false;
                    }
                });
            }

            if (!checkoutFormsValid) {
                return false;
            }

            if (isFreeForm) {
                submitForm = true;
            } else if ($paymentMethodRadios.length) {
                const $paymentMethodChecked = $paymentMethodRadios.filter(':checked'),
                    paymentMethod = $paymentMethodChecked.val();
                if (paymentMethod === 'Credit') {
                    var $radioNewCreditCard = $("#RadioNewCreditCard");
                    var $radioToken = $("#RadioToken");

                    if ($radioNewCreditCard.length) {
                        if (
                            $radioNewCreditCard.length &&
                            $radioNewCreditCard.is(":checked") &&
                            formInstance.isValid("Credit", true)
                        ) {
                            submitForm = true;
                        } else if ($radioToken.length && $radioToken.is(":checked")) {
                            submitForm = true;
                        }
                    } else if (formInstance.isValid('Credit', true)) {
                        submitForm = true;
                    }
                } else if (formInstance.isValid(paymentMethod, true)) {
                    submitForm = true;
                }
            }

            if (submitForm) {
                const $itemExtraDataFormInputs = $('.item-extra-data-form-input');
                if ($itemExtraDataFormInputs.length) {
                    $itemExtraDataFormInputs.remove();
                }

                if (itemExtraDataForms.length) {
                    itemExtraDataForms.forEach((itemsExtraDataForm) => {
                        const orderItemId = itemsExtraDataForm.find(field => field.name === 'OrderItemId');
                        if (!orderItemId) return;
                        for (let field of itemsExtraDataForm) {
                            $('<input>').attr({
                                type: 'hidden',
                                class: 'item-extra-data-form-input',
                                name: 'itemExtraData[' + orderItemId.value + '][' + field.name + ']',
                                value: field.value
                            }).appendTo($paymentForm);
                        }
                    });
                }

                // console.log('Stopping submission while testing');
                // return false;
                //console.log({paymentType, paymentPlanPayments, submitForm});

                $payNow.prop("disabled", true);
                $payNow.html(hpaTranslatedtext.payment.processingText); // Processing...

                const sendToGTM = $('.js-gtm-send').length;
                if (window.GtmDefined && sendToGTM) {
                    let paymentTypeOption = (paymentType === 'Credit' ? 'Credit Card' : paymentType),
                        paymentPlanOption = (paymentPlanPayments === '0' ? 'Full Payment' : paymentPlanPayments + ' Payments'),
                        gtmData = {};

                    // https://developers.google.com/tag-manager/enhanced-ecommerce#clear-ecommerce
                    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.

                    gtmData = {
                        'event': 'eec.checkout',
                        'ecommerce': {
                          'checkout': {
                            'actionField': {
                                'step': 3,
                            }
                          }
                        },
                        'eventTimeout' : 2000
                    };
                    // console.log(gtmData);
                    window.dataLayer.push(gtmData);

                    // https://developers.google.com/tag-manager/enhanced-ecommerce#clear-ecommerce
                    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.

                    gtmData = {
                        'event': 'eec.checkoutOption',
                        'ecommerce': {
                          'checkout_option': {
                            'actionField': {
                                'step': 3,
                                'option': paymentTypeOption,
                                'action': 'checkout_option'
                            }
                          }
                        },
                        'eventTimeout' : 2000
                    };
                    // console.log(gtmData);
                    window.dataLayer.push(gtmData);

                    // https://developers.google.com/tag-manager/enhanced-ecommerce#clear-ecommerce
                    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.

                    gtmData = {
                        'event': 'eec.checkout',
                        'ecommerce': {
                          'checkout': {
                            'actionField': {
                                'step': 4,
                            }
                          }
                        },
                        'eventTimeout' : 2000
                    };
                    // console.log(gtmData);
                    window.dataLayer.push(gtmData);

                    // https://developers.google.com/tag-manager/enhanced-ecommerce#clear-ecommerce
                    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.

                    gtmData = {
                        'event': 'eec.checkoutOption',
                        'ecommerce': {
                          'checkout_option': {
                            'actionField': {
                                'step': 4,
                                'option': paymentPlanOption,
                                'action': 'checkout_option'
                            }
                          }
                        },
                        'eventTimeout' : 2000
                    };
                    // console.log(gtmData);
                    window.dataLayer.push(gtmData);
                }

                document.getElementById('PaymentConfirmationForm_PaymentConfirmationForm').submit();

            } else {
                // stop form submission
                formInstance.submitEvent.preventDefault();

                $formError.show();
            }

            return;
        });
    }

    if ($membershipPaymentForm.length) {
        $membershipPaymentForm.parsley().subscribe("parsley:form:validate", function(formInstance) {
            // debugger;
            if ($credit.is(":checked") || $paypal.is(":checked") || $voucher.is(":checked")) {
                if ($credit.is(":checked")) {
                    var $radioNewCreditCard = $("#RadioNewCreditCard");
                    var $radioToken = $("#RadioToken");

                    if ($radioNewCreditCard.length) {
                        if (
                            $radioNewCreditCard.length &&
                            $radioNewCreditCard.is(":checked") &&
                            formInstance.isValid("Credit", true)
                        ) {
                            $payNow.prop("disabled", true);
                            $payNow.html(hpaTranslatedtext.payment.processingText); // Processing
                            formInstance.submit();
                        } else if ($radioToken.length && $radioToken.is(":checked")) {
                            $payNow.prop("disabled", true);
                            $payNow.html(hpaTranslatedtext.payment.processingText); // Processing
                            formInstance.submit();
                        }
                    } else if (formInstance.isValid("Credit", true)) {
                        $payNow.prop("disabled", true);
                        $payNow.html(hpaTranslatedtext.payment.processingText); // Processing
                        formInstance.submit();
                    }

                    return;
                } else if ($paypal.is(":checked") && formInstance.isValid("PayPal", true)) {
                    $payNow.prop("disabled", true);
                    $payNow.html("Processing");
                    formInstance.submit();
                    return;
                } else if ($voucher.is(":checked") && formInstance.isValid("Voucher", true)) {
                    $payNow.prop("disabled", true);
                    $payNow.html(hpaTranslatedtext.payment.processingText); // Processing
                    formInstance.submit();
                    return;
                }
            }
            // else stop form submission
            formInstance.submitEvent.preventDefault();

            return;
        });
    }

    $('.upsell-box .close-x').on('click', function() {
        const $this = $(this);

        $this.parent().hide();
    });

    const $voucherNumberFields = $('#step2-Voucher').find('input[name^="VoucherNumber"]');
    if ($voucherNumberFields.length) {
        $voucherNumberFields.on('paste', function(e) {
            const clipboardData = (e.originalEvent || e).clipboardData || window.clipboardData;
            if (!clipboardData) return;

            const code = clipboardData.getData('text').replace(/[\s-]/g, '');
            if (code.length <= 4) return;

            e.preventDefault();

            $voucherNumberFields.each(function(index) {
                $(this).val(code.substr(index * 4, 4)).trigger('change');
            });

            const lastFilledIndex = Math.min(Math.ceil(code.length / 4), $voucherNumberFields.length) - 1;
            $voucherNumberFields.eq(lastFilledIndex).trigger('focus');
        });

        $voucherNumberFields.on('input', function() {
            const $this = $(this);
            if ($this.val().length < 4) return;

            const nextIndex = $voucherNumberFields.index(this) + 1;
            if (nextIndex < $voucherNumberFields.length) {
                $voucherNumberFields.eq(nextIndex).trigger('focus');
            }
        });
    }

    $paymentPlanStepOverlay.on('click', function(e) {
        $formError.hide();
        loggedInCheck()
    });

    $paymentMethodsOverlay.on('click', function(e) {
        $formError.hide();
        loggedInCheck()
    });

    $paymentMethodsWrapper.find('input[type="radio"]').on('click', function(e) {
        $formError.hide();
    });

    function loggedInCheck() {
        let result = true;
        const orderID = forceInt($orderId.val());

        if (!orderID) {
            $notLoggedInError.show();
            $('html, body').animate(
                {
                    scrollTop: ($loginRegisterSection.offset().top - 20),
                },
                {
                    complete: function() {
                        let $fieldEmail = $('#HPALoginRegisterForm_HPALoginRegisterForm_Email');
                        if (!$fieldEmail.length) $fieldEmail = $('#HPACheckoutEmailForm_HPACheckoutEmailForm_Email');
                        if ($fieldEmail.length) $fieldEmail.focus();
                    }
                }
            );

            result = false;
        }

        return result;
    }

    const updateTotals = function(total) {
        total = forceFloat(total);
        const $orderTotal = $('#order-total');
        if ($orderTotal.length) {
            $orderTotal.data('order-total', total);
        }

        const $totals = $('.js-total');
        if ($totals.length) {
            $totals.each(function() {
                const $this = $(this),
                    weeks = forceInt($this.data('weeks'));
                if (weeks > 1) {
                    let totalpp = forceFloat(total / weeks),
                        totalFormatted = totalpp.toFixed(2);
                    $this.text('$' + totalFormatted + ' USD');
                } else {
                    let totalFormatted = total.toFixed(2);
                    $this.text('$' + totalFormatted + ' USD');
                }
            });

            updateUnderBtnText();
        }
    };

    const updateUnderBtnText = function() {
        if ($underBtnText.length) {
            const selectedOption = ppSelectedOption();
            if (selectedOption && selectedOption.length) {
                const $label = selectedOption.parent('li').find('label');
                if ($label.length) {
                    $underBtnText.text($label.text());
                }
            }
        }
    }

    if ($ppSections.length && $ppOptions.length && $ppBtns.length) {
        $ppBtns.find('a').on('click', function(e) {
            e.preventDefault();

            const $this = $(this),
                action = $this.data('action');

            if (action === 'optionsShow') {
                ppOptionsShow();
            } else if (action === 'paymentMethodsEnable') {
                if (getOrderId()) {
                    layoutState.desktop.paymentMethodsDisabled = false;
                    updateOverlays();
                }
            }
        });

        const $ppOption = $('.paymentplan-option');
        if ($ppOption.length) {
            $ppOption.on('click', function() {
                const $this = $(this),
                    val = $this.val(),
                    optionClass = 'paymentplan-option-' + val,
                    $options = $('.' + optionClass);

                if ($options.length) {
                    $options.prop('checked', true);
                }

                updateUnderBtnText();
            });
        }
    }

    if (getUrlParameter('paymentplan') === '1') {
        const $checkedOption = $('.paymentplan-option:checked').first();
        if (!$checkedOption.length || $checkedOption.val() === '0') {
            ppOptionsSelectLowest();
        }
        ppOptionsShow();
    } else if ($ppOptions.length) {
        if (ppOptionsSelectedValue() !== '0') {
            ppOptionsShow();
        }
    } else {
        $('.highlight.step3').text('2'); // There are no payment plan options so "Step 3" need to be called "Step 2".
    }

    const orderID = forceInt($orderId.val());
    if (!orderID) {
        // $paymentPlanStepOverlay.show();
        // $paymentMethodsOverlay.show();
        layoutState.mobile.paymentMethodsDisabled = true;
        layoutState.desktop.paymentPlanOptionsDisabled = true;
        layoutState.desktop.paymentMethodsDisabled = true;
    } else if (!$ppOptions.length) { // There are no payment plan options available on this product
        layoutState.mobile.paymentMethodsDisabled = false;
        layoutState.desktop.paymentPlanOptionsDisabled = false;
        layoutState.desktop.paymentMethodsDisabled = false;
    }

    updateOverlays();

    $(window).resize(function() {
        updateOverlays();
    });
});



// WEBPACK FOOTER //
// ./js/modules/confirmation.js